/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiCompetitionsAllGet200Response } from '../models';
// @ts-ignore
import type { ApiCompetitionsEnabledGet200Response } from '../models';
// @ts-ignore
import type { ApiCompetitionsGet200Response } from '../models';
// @ts-ignore
import type { ApiCompetitorCompetitorIdGet200Response } from '../models';
// @ts-ignore
import type { ApiFavoritesIdsGet200Response } from '../models';
// @ts-ignore
import type { ApiFormationsEventIdGet200Response } from '../models';
// @ts-ignore
import type { ApiH2hGet200Response } from '../models';
// @ts-ignore
import type { ApiLeagueIdsIdsGet200Response } from '../models';
// @ts-ignore
import type { ApiLeagueLeagueIdGet200Response } from '../models';
// @ts-ignore
import type { ApiLeagueSeasonSeasonIdEventsGet200Response } from '../models';
// @ts-ignore
import type { ApiLivescoreDateOddsGet200Response } from '../models';
// @ts-ignore
import type { ApiLivescoreLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdAllLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdPreviewGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdTimelineGet200Response } from '../models';
// @ts-ignore
import type { ApiMatchEventIdTimelineLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiPlayerPlayerIdGet200Response } from '../models';
// @ts-ignore
import type { ApiPlayerPlayerIdStatsGet200Response } from '../models';
// @ts-ignore
import type { ApiPlayersGet200Response } from '../models';
// @ts-ignore
import type { ApiSearchGet200Response } from '../models';
// @ts-ignore
import type { ApiSearchLeaguesGet200Response } from '../models';
// @ts-ignore
import type { ApiSearchPlayersGet200Response } from '../models';
// @ts-ignore
import type { ApiSeasonTableSeasonIdGet200Response } from '../models';
// @ts-ignore
import type { ApiTeamsGet200Response } from '../models';
/**
 * ApiApi - axios parameter creator
 * @export
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsAllGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsCountriesConfigGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions/countries-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsEnabledGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions/enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/competitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitorCompetitorIdGet: async (competitorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitorId' is not null or undefined
            assertParamExists('apiCompetitorCompetitorIdGet', 'competitorId', competitorId)
            const localVarPath = `/api/competitor/{competitor_id}`
                .replace(`{${"competitor_id"}}`, encodeURIComponent(String(competitorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiFavoritesGet', 'ids', ids)
            const localVarPath = `/api/favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesIdsGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiFavoritesIdsGet', 'ids', ids)
            const localVarPath = `/api/favorites/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormationsEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiFormationsEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/formations/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiH2hGet: async (homeId: string, awayId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'homeId' is not null or undefined
            assertParamExists('apiH2hGet', 'homeId', homeId)
            // verify required parameter 'awayId' is not null or undefined
            assertParamExists('apiH2hGet', 'awayId', awayId)
            const localVarPath = `/api/h2h/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (homeId !== undefined) {
                localVarQueryParameter['home_id'] = homeId;
            }

            if (awayId !== undefined) {
                localVarQueryParameter['away_id'] = awayId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueIdsIdsGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiLeagueIdsIdsGet', 'ids', ids)
            const localVarPath = `/api/league/ids/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueLeagueIdGet: async (leagueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('apiLeagueLeagueIdGet', 'leagueId', leagueId)
            const localVarPath = `/api/league/{league_id}`
                .replace(`{${"league_id"}}`, encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueSeasonSeasonIdEventsGet: async (seasonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('apiLeagueSeasonSeasonIdEventsGet', 'seasonId', seasonId)
            const localVarPath = `/api/league/season/{season_id}/events`
                .replace(`{${"season_id"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateGet: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiLivescoreDateGet', 'date', date)
            const localVarPath = `/api/livescore/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateOddsGet: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiLivescoreDateOddsGet', 'date', date)
            const localVarPath = `/api/livescore/{date}/odds`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreLiveGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/livescore/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdAllLiveGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdAllLiveGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/all/live`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdLiveGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdLiveGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/live`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdPreviewGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdPreviewGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/preview`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdTimelineGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/timeline`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineLiveGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiMatchEventIdTimelineLiveGet', 'eventId', eventId)
            const localVarPath = `/api/match/{event_id}/timeline/live`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdGet: async (playerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('apiPlayerPlayerIdGet', 'playerId', playerId)
            const localVarPath = `/api/player/{player_id}`
                .replace(`{${"player_id"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdStatsGet: async (playerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('apiPlayerPlayerIdStatsGet', 'playerId', playerId)
            const localVarPath = `/api/player/{player_id}/stats`
                .replace(`{${"player_id"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersIdsGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiPlayersIdsGet', 'ids', ids)
            const localVarPath = `/api/players/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchGet: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiSearchGet', 'q', q)
            const localVarPath = `/api/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchLeaguesGet: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiSearchLeaguesGet', 'q', q)
            const localVarPath = `/api/search/leagues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchPlayersGet: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiSearchPlayersGet', 'q', q)
            const localVarPath = `/api/search/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSeasonTableSeasonIdGet: async (seasonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('apiSeasonTableSeasonIdGet', 'seasonId', seasonId)
            const localVarPath = `/api/season-table/{season_id}`
                .replace(`{${"season_id"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiApi - functional programming interface
 * @export
 */
export const ApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsAllGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitionsAllGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsAllGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiCompetitionsAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsCountriesConfigGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsCountriesConfigGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiCompetitionsCountriesConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsEnabledGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitionsEnabledGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsEnabledGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiCompetitionsEnabledGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitionsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiCompetitionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitorCompetitorIdGet(competitorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitorCompetitorIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitorCompetitorIdGet(competitorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiCompetitorCompetitorIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFavoritesGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFavoritesIdsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFavoritesGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiFavoritesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get favorites matches by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFavoritesIdsGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFavoritesIdsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFavoritesIdsGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiFavoritesIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get formations by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormationsEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiFormationsEventIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormationsEventIdGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiFormationsEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get h2h by id from Sportradar API
         * @param {string} homeId 
         * @param {string} awayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiH2hGet(homeId: string, awayId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiH2hGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiH2hGet(homeId, awayId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiH2hGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeagueIdsIdsGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLeagueIdsIdsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLeagueIdsIdsGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiLeagueIdsIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeagueLeagueIdGet(leagueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLeagueLeagueIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLeagueLeagueIdGet(leagueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiLeagueLeagueIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeagueSeasonSeasonIdEventsGet(seasonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLeagueSeasonSeasonIdEventsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLeagueSeasonSeasonIdEventsGet(seasonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiLeagueSeasonSeasonIdEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreDateGet(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreDateGet(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiLivescoreDateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreDateOddsGet(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreDateOddsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreDateOddsGet(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiLivescoreDateOddsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreLiveGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreLiveGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiLivescoreLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdAllLiveGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdAllLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdAllLiveGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiMatchEventIdAllLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiMatchEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdLiveGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdLiveGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiMatchEventIdLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdPreviewGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdPreviewGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdPreviewGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiMatchEventIdPreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdTimelineGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdTimelineGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdTimelineGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiMatchEventIdTimelineGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatchEventIdTimelineLiveGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMatchEventIdTimelineLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatchEventIdTimelineLiveGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiMatchEventIdTimelineLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get player by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerPlayerIdGet(playerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayerPlayerIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayerPlayerIdGet(playerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiPlayerPlayerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerPlayerIdStatsGet(playerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayerPlayerIdStatsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayerPlayerIdStatsGet(playerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiPlayerPlayerIdStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiPlayersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayersIdsGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayersIdsGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiPlayersIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for players, teams, competitions
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSearchGet(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSearchGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSearchGet(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for leagues
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSearchLeaguesGet(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSearchLeaguesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSearchLeaguesGet(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiSearchLeaguesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for players
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSearchPlayersGet(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSearchPlayersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSearchPlayersGet(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiSearchPlayersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get league table by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSeasonTableSeasonIdGet(seasonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSeasonTableSeasonIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSeasonTableSeasonIdGet(seasonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiSeasonTableSeasonIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiApi.apiTeamsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiApi - factory interface
 * @export
 */
export const ApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiApiFp(configuration)
    return {
        /**
         * Get all competitions from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsAllGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitionsAllGet200Response> {
            return localVarFp.apiCompetitionsAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get configured countries for the AllCompetitions display
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsCountriesConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCompetitionsCountriesConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get enabled competitions from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsEnabledGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitionsEnabledGet200Response> {
            return localVarFp.apiCompetitionsEnabledGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get enabled and all competitions from configured leagues and Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitionsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitionsGet200Response> {
            return localVarFp.apiCompetitionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get competitor by id from Sportradar API
         * @param {ApiApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitorCompetitorIdGet(requestParameters: ApiApiApiCompetitorCompetitorIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitorCompetitorIdGet200Response> {
            return localVarFp.apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get favorites matches by ids
         * @param {ApiApiApiFavoritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesGet(requestParameters: ApiApiApiFavoritesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiFavoritesIdsGet200Response> {
            return localVarFp.apiFavoritesGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get favorites matches by ids
         * @param {ApiApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFavoritesIdsGet(requestParameters: ApiApiApiFavoritesIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiFavoritesIdsGet200Response> {
            return localVarFp.apiFavoritesIdsGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get formations by id from Sportradar API
         * @param {ApiApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormationsEventIdGet(requestParameters: ApiApiApiFormationsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiFormationsEventIdGet200Response> {
            return localVarFp.apiFormationsEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get h2h by id from Sportradar API
         * @param {ApiApiApiH2hGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiH2hGet(requestParameters: ApiApiApiH2hGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiH2hGet200Response> {
            return localVarFp.apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {ApiApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueIdsIdsGet(requestParameters: ApiApiApiLeagueIdsIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLeagueIdsIdsGet200Response> {
            return localVarFp.apiLeagueIdsIdsGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get league by id from Sportradar API
         * @param {ApiApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueLeagueIdGet(requestParameters: ApiApiApiLeagueLeagueIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLeagueLeagueIdGet200Response> {
            return localVarFp.apiLeagueLeagueIdGet(requestParameters.leagueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get season events by id from Sportradar API
         * @param {ApiApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueSeasonSeasonIdEventsGet(requestParameters: ApiApiApiLeagueSeasonSeasonIdEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLeagueSeasonSeasonIdEventsGet200Response> {
            return localVarFp.apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get matches for the provided date
         * @param {ApiApiApiLivescoreDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateGet(requestParameters: ApiApiApiLivescoreDateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreLiveGet200Response> {
            return localVarFp.apiLivescoreDateGet(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get odds for the provided date
         * @param {ApiApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateOddsGet(requestParameters: ApiApiApiLivescoreDateOddsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreDateOddsGet200Response> {
            return localVarFp.apiLivescoreDateOddsGet(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreLiveGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreLiveGet200Response> {
            return localVarFp.apiLivescoreLiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {ApiApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdAllLiveGet(requestParameters: ApiApiApiMatchEventIdAllLiveGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdAllLiveGet200Response> {
            return localVarFp.apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match by id from Sportradar API
         * @param {ApiApiApiMatchEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdGet(requestParameters: ApiApiApiMatchEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdGet200Response> {
            return localVarFp.apiMatchEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match live data by id from Sportradar API
         * @param {ApiApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdLiveGet(requestParameters: ApiApiApiMatchEventIdLiveGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdLiveGet200Response> {
            return localVarFp.apiMatchEventIdLiveGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
         * @param {ApiApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdPreviewGet(requestParameters: ApiApiApiMatchEventIdPreviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdPreviewGet200Response> {
            return localVarFp.apiMatchEventIdPreviewGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match timeline by id from Sportradar API
         * @param {ApiApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineGet(requestParameters: ApiApiApiMatchEventIdTimelineGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdTimelineGet200Response> {
            return localVarFp.apiMatchEventIdTimelineGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get match live timeline data by id from Sportradar API
         * @param {ApiApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatchEventIdTimelineLiveGet(requestParameters: ApiApiApiMatchEventIdTimelineLiveGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMatchEventIdTimelineLiveGet200Response> {
            return localVarFp.apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get player by id from Sportradar API
         * @param {ApiApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdGet(requestParameters: ApiApiApiPlayerPlayerIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayerPlayerIdGet200Response> {
            return localVarFp.apiPlayerPlayerIdGet(requestParameters.playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get player statistics by id from Sportradar API
         * @param {ApiApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerPlayerIdStatsGet(requestParameters: ApiApiApiPlayerPlayerIdStatsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayerPlayerIdStatsGet200Response> {
            return localVarFp.apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayersGet200Response> {
            return localVarFp.apiPlayersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get favorites players by ids
         * @param {ApiApiApiPlayersIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersIdsGet(requestParameters: ApiApiApiPlayersIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayersGet200Response> {
            return localVarFp.apiPlayersIdsGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for players, teams, competitions
         * @param {ApiApiApiSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchGet(requestParameters: ApiApiApiSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSearchGet200Response> {
            return localVarFp.apiSearchGet(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for leagues
         * @param {ApiApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchLeaguesGet(requestParameters: ApiApiApiSearchLeaguesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSearchLeaguesGet200Response> {
            return localVarFp.apiSearchLeaguesGet(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for players
         * @param {ApiApiApiSearchPlayersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSearchPlayersGet(requestParameters: ApiApiApiSearchPlayersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSearchPlayersGet200Response> {
            return localVarFp.apiSearchPlayersGet(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Get league table by id from Sportradar API
         * @param {ApiApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSeasonTableSeasonIdGet(requestParameters: ApiApiApiSeasonTableSeasonIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiSeasonTableSeasonIdGet200Response> {
            return localVarFp.apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all teams from Sportradar API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsGet200Response> {
            return localVarFp.apiTeamsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCompetitorCompetitorIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiCompetitorCompetitorIdGetRequest
 */
export interface ApiApiApiCompetitorCompetitorIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiCompetitorCompetitorIdGet
     */
    readonly competitorId: string
}

/**
 * Request parameters for apiFavoritesGet operation in ApiApi.
 * @export
 * @interface ApiApiApiFavoritesGetRequest
 */
export interface ApiApiApiFavoritesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiFavoritesGet
     */
    readonly ids: string
}

/**
 * Request parameters for apiFavoritesIdsGet operation in ApiApi.
 * @export
 * @interface ApiApiApiFavoritesIdsGetRequest
 */
export interface ApiApiApiFavoritesIdsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiFavoritesIdsGet
     */
    readonly ids: string
}

/**
 * Request parameters for apiFormationsEventIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiFormationsEventIdGetRequest
 */
export interface ApiApiApiFormationsEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiFormationsEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiH2hGet operation in ApiApi.
 * @export
 * @interface ApiApiApiH2hGetRequest
 */
export interface ApiApiApiH2hGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiH2hGet
     */
    readonly homeId: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiH2hGet
     */
    readonly awayId: string
}

/**
 * Request parameters for apiLeagueIdsIdsGet operation in ApiApi.
 * @export
 * @interface ApiApiApiLeagueIdsIdsGetRequest
 */
export interface ApiApiApiLeagueIdsIdsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiLeagueIdsIdsGet
     */
    readonly ids: string
}

/**
 * Request parameters for apiLeagueLeagueIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiLeagueLeagueIdGetRequest
 */
export interface ApiApiApiLeagueLeagueIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiLeagueLeagueIdGet
     */
    readonly leagueId: string
}

/**
 * Request parameters for apiLeagueSeasonSeasonIdEventsGet operation in ApiApi.
 * @export
 * @interface ApiApiApiLeagueSeasonSeasonIdEventsGetRequest
 */
export interface ApiApiApiLeagueSeasonSeasonIdEventsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiLeagueSeasonSeasonIdEventsGet
     */
    readonly seasonId: string
}

/**
 * Request parameters for apiLivescoreDateGet operation in ApiApi.
 * @export
 * @interface ApiApiApiLivescoreDateGetRequest
 */
export interface ApiApiApiLivescoreDateGetRequest {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof ApiApiApiLivescoreDateGet
     */
    readonly date: string
}

/**
 * Request parameters for apiLivescoreDateOddsGet operation in ApiApi.
 * @export
 * @interface ApiApiApiLivescoreDateOddsGetRequest
 */
export interface ApiApiApiLivescoreDateOddsGetRequest {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof ApiApiApiLivescoreDateOddsGet
     */
    readonly date: string
}

/**
 * Request parameters for apiMatchEventIdAllLiveGet operation in ApiApi.
 * @export
 * @interface ApiApiApiMatchEventIdAllLiveGetRequest
 */
export interface ApiApiApiMatchEventIdAllLiveGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiMatchEventIdAllLiveGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiMatchEventIdGetRequest
 */
export interface ApiApiApiMatchEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiMatchEventIdGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdLiveGet operation in ApiApi.
 * @export
 * @interface ApiApiApiMatchEventIdLiveGetRequest
 */
export interface ApiApiApiMatchEventIdLiveGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiMatchEventIdLiveGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdPreviewGet operation in ApiApi.
 * @export
 * @interface ApiApiApiMatchEventIdPreviewGetRequest
 */
export interface ApiApiApiMatchEventIdPreviewGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiMatchEventIdPreviewGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdTimelineGet operation in ApiApi.
 * @export
 * @interface ApiApiApiMatchEventIdTimelineGetRequest
 */
export interface ApiApiApiMatchEventIdTimelineGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiMatchEventIdTimelineGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiMatchEventIdTimelineLiveGet operation in ApiApi.
 * @export
 * @interface ApiApiApiMatchEventIdTimelineLiveGetRequest
 */
export interface ApiApiApiMatchEventIdTimelineLiveGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiMatchEventIdTimelineLiveGet
     */
    readonly eventId: string
}

/**
 * Request parameters for apiPlayerPlayerIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiPlayerPlayerIdGetRequest
 */
export interface ApiApiApiPlayerPlayerIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiPlayerPlayerIdGet
     */
    readonly playerId: string
}

/**
 * Request parameters for apiPlayerPlayerIdStatsGet operation in ApiApi.
 * @export
 * @interface ApiApiApiPlayerPlayerIdStatsGetRequest
 */
export interface ApiApiApiPlayerPlayerIdStatsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiPlayerPlayerIdStatsGet
     */
    readonly playerId: string
}

/**
 * Request parameters for apiPlayersIdsGet operation in ApiApi.
 * @export
 * @interface ApiApiApiPlayersIdsGetRequest
 */
export interface ApiApiApiPlayersIdsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiPlayersIdsGet
     */
    readonly ids: string
}

/**
 * Request parameters for apiSearchGet operation in ApiApi.
 * @export
 * @interface ApiApiApiSearchGetRequest
 */
export interface ApiApiApiSearchGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiSearchGet
     */
    readonly q: string
}

/**
 * Request parameters for apiSearchLeaguesGet operation in ApiApi.
 * @export
 * @interface ApiApiApiSearchLeaguesGetRequest
 */
export interface ApiApiApiSearchLeaguesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiSearchLeaguesGet
     */
    readonly q: string
}

/**
 * Request parameters for apiSearchPlayersGet operation in ApiApi.
 * @export
 * @interface ApiApiApiSearchPlayersGetRequest
 */
export interface ApiApiApiSearchPlayersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiSearchPlayersGet
     */
    readonly q: string
}

/**
 * Request parameters for apiSeasonTableSeasonIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiSeasonTableSeasonIdGetRequest
 */
export interface ApiApiApiSeasonTableSeasonIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiSeasonTableSeasonIdGet
     */
    readonly seasonId: string
}

/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
export class ApiApi extends BaseAPI {
    /**
     * Get all competitions from Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiCompetitionsAllGet(options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiCompetitionsAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get configured countries for the AllCompetitions display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiCompetitionsCountriesConfigGet(options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiCompetitionsCountriesConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get enabled competitions from configured leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiCompetitionsEnabledGet(options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiCompetitionsEnabledGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get enabled and all competitions from configured leagues and Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiCompetitionsGet(options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiCompetitionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get competitor by id from Sportradar API
     * @param {ApiApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiCompetitorCompetitorIdGet(requestParameters: ApiApiApiCompetitorCompetitorIdGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get favorites matches by ids
     * @param {ApiApiApiFavoritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiFavoritesGet(requestParameters: ApiApiApiFavoritesGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiFavoritesGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get favorites matches by ids
     * @param {ApiApiApiFavoritesIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiFavoritesIdsGet(requestParameters: ApiApiApiFavoritesIdsGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiFavoritesIdsGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get formations by id from Sportradar API
     * @param {ApiApiApiFormationsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiFormationsEventIdGet(requestParameters: ApiApiApiFormationsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiFormationsEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get h2h by id from Sportradar API
     * @param {ApiApiApiH2hGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiH2hGet(requestParameters: ApiApiApiH2hGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiH2hGet(requestParameters.homeId, requestParameters.awayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get league by ids separated by \",\" from Sportradar API
     * @param {ApiApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiLeagueIdsIdsGet(requestParameters: ApiApiApiLeagueIdsIdsGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiLeagueIdsIdsGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get league by id from Sportradar API
     * @param {ApiApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiLeagueLeagueIdGet(requestParameters: ApiApiApiLeagueLeagueIdGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiLeagueLeagueIdGet(requestParameters.leagueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get season events by id from Sportradar API
     * @param {ApiApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiLeagueSeasonSeasonIdEventsGet(requestParameters: ApiApiApiLeagueSeasonSeasonIdEventsGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get matches for the provided date
     * @param {ApiApiApiLivescoreDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiLivescoreDateGet(requestParameters: ApiApiApiLivescoreDateGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiLivescoreDateGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get odds for the provided date
     * @param {ApiApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiLivescoreDateOddsGet(requestParameters: ApiApiApiLivescoreDateOddsGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiLivescoreDateOddsGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get live matches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiLivescoreLiveGet(options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiLivescoreLiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match live timeline data by id from Sportradar API
     * @param {ApiApiApiMatchEventIdAllLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiMatchEventIdAllLiveGet(requestParameters: ApiApiApiMatchEventIdAllLiveGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiMatchEventIdAllLiveGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match by id from Sportradar API
     * @param {ApiApiApiMatchEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiMatchEventIdGet(requestParameters: ApiApiApiMatchEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiMatchEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match live data by id from Sportradar API
     * @param {ApiApiApiMatchEventIdLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiMatchEventIdLiveGet(requestParameters: ApiApiApiMatchEventIdLiveGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiMatchEventIdLiveGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match preview by id from Sportradar API. It has steps: generating preview, fetching, error, success. It should be listen to the error, result and status event names.
     * @param {ApiApiApiMatchEventIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiMatchEventIdPreviewGet(requestParameters: ApiApiApiMatchEventIdPreviewGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiMatchEventIdPreviewGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match timeline by id from Sportradar API
     * @param {ApiApiApiMatchEventIdTimelineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiMatchEventIdTimelineGet(requestParameters: ApiApiApiMatchEventIdTimelineGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiMatchEventIdTimelineGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get match live timeline data by id from Sportradar API
     * @param {ApiApiApiMatchEventIdTimelineLiveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiMatchEventIdTimelineLiveGet(requestParameters: ApiApiApiMatchEventIdTimelineLiveGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiMatchEventIdTimelineLiveGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get player by id from Sportradar API
     * @param {ApiApiApiPlayerPlayerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiPlayerPlayerIdGet(requestParameters: ApiApiApiPlayerPlayerIdGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiPlayerPlayerIdGet(requestParameters.playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get player statistics by id from Sportradar API
     * @param {ApiApiApiPlayerPlayerIdStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiPlayerPlayerIdStatsGet(requestParameters: ApiApiApiPlayerPlayerIdStatsGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiPlayerPlayerIdStatsGet(requestParameters.playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all players
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiPlayersGet(options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiPlayersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get favorites players by ids
     * @param {ApiApiApiPlayersIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiPlayersIdsGet(requestParameters: ApiApiApiPlayersIdsGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiPlayersIdsGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for players, teams, competitions
     * @param {ApiApiApiSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSearchGet(requestParameters: ApiApiApiSearchGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSearchGet(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for leagues
     * @param {ApiApiApiSearchLeaguesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSearchLeaguesGet(requestParameters: ApiApiApiSearchLeaguesGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSearchLeaguesGet(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for players
     * @param {ApiApiApiSearchPlayersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSearchPlayersGet(requestParameters: ApiApiApiSearchPlayersGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSearchPlayersGet(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get league table by id from Sportradar API
     * @param {ApiApiApiSeasonTableSeasonIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSeasonTableSeasonIdGet(requestParameters: ApiApiApiSeasonTableSeasonIdGetRequest, options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSeasonTableSeasonIdGet(requestParameters.seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all teams from Sportradar API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiTeamsGet(options?: RawAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiTeamsGet(options).then((request) => request(this.axios, this.basePath));
    }
}

